import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Chart, registerables } from 'chart.js'
import { BarChart, useBarChart } from 'vue-chart-3'
import { computed, PropType } from 'vue'
import {
  StatisticReportType,
  StatisticGroupType,
  StatisticDatasetType,
  StatisticAppointmentType,
} from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  reports: Array as PropType<
    StatisticReportType[] | StatisticAppointmentType[]
  >,
},
  setup(__props) {

const props = __props

Chart.register(...registerables)



const datasets = computed((): StatisticDatasetType[] => {
  const statisticDatasets: StatisticDatasetType[] = []

  let maxDataCount = 0

  for (const group of statisticGroups.value) {
    if (group.groupData.length > maxDataCount) {
      maxDataCount = group.groupData.length
    }
  }

  for (const group of statisticGroups.value) {
    for (let i = 0; i < maxDataCount; i++) {
      try {
        if (group.groupData[i]) {
          statisticDatasets[i].data.push(group.groupData[i])
        } else {
          statisticDatasets[i].data.push(0)
        }
      } catch {
        statisticDatasets.push({ data: [], backgroundColor: [] })

        statisticDatasets[i].data.push(group.groupData[i])
      } finally {
        statisticDatasets[i].backgroundColor.push('#d8d5ed')
      }
    }
  }

  return statisticDatasets
})

const statisticGroups = computed((): StatisticGroupType[] => {
  const newStatisticGroups: StatisticGroupType[] = []
  const dateList = getDateList()

  for (const date of dateList) {
    const statisticGroup: StatisticGroupType = {
      date: date.substr(0, 5),
      groupData: [],
    }

    for (const report of props.reports) {
      if (report.date === date) {
        statisticGroup.groupData.push(report.count)
      }
    }

    newStatisticGroups.push(statisticGroup)
  }

  return newStatisticGroups
})

const labels = computed(() => statisticGroups.value.map((group) => group.date))

const chartData = computed(() => ({
  labels: labels.value,
  datasets: datasets.value,
}))

const options = computed(() => ({
  indexAxis: 'x',
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        tickColor: 'transparent',
        drawOnChartArea: false,
      },
      ticks: {
        font: {
          size: 10,
        },
      },
    },
    y: {
      grid: {
        tickColor: 'transparent',
        drawBorder: false,
      },
      max: getMaxStatisticValue(),
      ticks: {
        stepSize: 5,
        font: {
          size: 12,
        },
      },
    },
  },
  hoverBackgroundColor: '#73c707',
}))

const getDateList = (): string[] => {
  const dateList: string[] = []

  for (const report of props.reports) {
    if (!dateList.includes(report.date)) {
      dateList.push(report.date)
    }
  }

  return dateList
}

const getMaxStatisticValue = (): number => {
  let maxStatisticValue = 0

  for (const group of statisticGroups.value) {
    const maxGroupValue = Math.max(...group.groupData)

    if (maxGroupValue > maxStatisticValue) {
      maxStatisticValue = maxGroupValue
    }
  }

  return maxStatisticValue
}

const { barChartProps } = useBarChart({
  chartData: chartData.value,
  options,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BarChart), _mergeProps({ class: "statistic-chart" }, _unref(barChartProps)), null, 16))
}
}

})